'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

// Fuerza el scroll arriba en cada cambio de pantalla (avanzar o volver), sin
// depender de la restauración nativa del navegador: al volver desde el
// detalle de un evento (donde se hizo scroll para leer más), el navegador
// restaura la posición previa de scroll de la pantalla anterior, que puede
// quedar en cualquier punto (ej. el footer). Solo depende del pathname, no
// de searchParams, para no interferir con cambios de filtros en /eventos
// que usan router.replace(..., { scroll: false }) sobre la misma ruta.
export function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
